import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import WhereToBuy from "../pages/where-to-buy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/where-to-buy",
    element: <WhereToBuy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
